import type React from 'react';
import { type ReactElement, useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

interface PortalProps {
    children: React.ReactNode;
    selector: string;
}

export const Portal = ({ children, selector }: PortalProps): ReactElement | null => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
        };
    }, []);

    if (typeof window === 'undefined' || !mounted) {
        // Server-side rendering or not yet mounted
        return null;
    }

    const portalRoot = document.querySelector(selector);

    if (!portalRoot) {
        return null;
    }
    return createPortal(children, portalRoot);
};
